import { Injectable } from '@angular/core';
import {
  GoogleGenerativeAI, HarmBlockThreshold, HarmCategory 
} from '@google/generative-ai';


@Injectable({
  providedIn: 'root'
})
export class GeminiService {

  constructor() { }

  async TestGeminiPro() {
    // Model initialisation missing for brevity
    const genAI = new GoogleGenerativeAI('AIzaSyC7yo_TDGZelfo2_3Vs-BEFohEwcrlU9Ww');

    const generationConfig = {
      safetySettings: [
        {
          category: HarmCategory.HARM_CATEGORY_HARASSMENT,
          threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE,
        },
      ],
      temperature: 0.9,
      top_p: 1,
      top_k: 32,
      maxOutputTokens: 100, // limit output
    };
    
    const model = genAI.getGenerativeModel({
      model: 'gemini-pro', // or 'gemini-pro-vision'
      ...generationConfig,
    });
    const chat = model.startChat({
      history: [
        {
          role: "user",
          parts: [{text:"Hi there!"}],
        },
        {
          role: "model",
          parts: [{text:"Great to meet you. What would you like to know?"}],
        },
      ],
      generationConfig: {
        maxOutputTokens: 100,
      },
    });
    const prompt = 'What is the largest number with a name? Brief answer.';
    const result = await chat.sendMessage(prompt);
    const response = await result.response;
    console.log(response.text());
  }
}
